import axiosInstance from '../Config/AxiosInstance';

//const PREFIX = `/clinic/jobboard`;
const PREFIX = `/clinic/job-board`;

export const getListofJobs = (
  statuses = '',
  pageNo = 0,
  pageSize = 20,
  createdFrom = '',
  createdTill = '',
  count = false,
  doctorIds = '',
  facilityIds = '',
  sortKeys = '',
  sortOrder = ''
) => {
  const url = `${PREFIX}?count=${count}&page=${pageNo}&size=${pageSize}&statuses=${statuses}&doctorIds=${doctorIds}&facilityIds=${facilityIds}&createdFrom=${createdFrom}&createdTill=${createdTill}&sortKeys=${sortKeys}&sortOrder=${sortOrder}`;
  return axiosInstance.get(url);
};
export const getDoctorsOfUser = (facilityIds) => {
  return axiosInstance.get(PREFIX + `/doctors?facilityIds=${facilityIds}`);
};
export const getListOfFacilities = () => {
  return axiosInstance.get(PREFIX + '/facilities');
};
export const getJobBoardsUser = () => {
  return axiosInstance.get(PREFIX + '/boards');
};
// export const postJobBoardsUser = jobBoardRequest => {
//   return axiosInstance.post(PREFIX + '/system', jobBoardRequest);
// };
export const postJobBoardsUser = jobBoardRequest => {
  return axiosInstance.post(PREFIX + '/boards', jobBoardRequest);
};
export const getJobBoardByStatusAndDate = (
  statuses = '',
  createdFrom = '',
  createdTill = '',
  count = false
) => {
  let url = `${PREFIX}?statuses=${statuses}&count=${count}`;
  if (createdFrom) url += `&createdFrom=${createdFrom}`;
  if (createdTill) url += `&createdTill=${createdTill}`;
  return axiosInstance.get(url);
};

export const downloadJobBoard = payload => {
  return axiosInstance.post('/clinic/job-board/download', payload, {
    responseType: 'blob' // Important for CSV or binary files
  });
};
